import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
